import { createContext } from 'react';
export const TabsContext = createContext({
    activeTabId: undefined,
    orientation: 'horizontal',
    setActiveTabRef: undefined,
    layout: undefined,
    variant: 'solid',
});
//# sourceMappingURL=TabsContext.js.map